import { debounce } from './_utilities';

// detects if content (i.e. table) within a container overflows on the X axis, then displays swipe hint
//
// see /_src/markup/xfinity/internet for example usage

const detectXOverflow = () => {
    // const swipeHintTargetDiv = $('div').find('[data-swipe-hint-target]');
    // const swipeHintTargetTable = swipeHintTargetDiv.get(0); // warning: assumes table is next tag within div
    const swipeHintTargetDivs = document.querySelectorAll(
        '[data-swipe-hint-target]'
    );

    swipeHintTargetDivs.forEach((swipeHintTargetDiv) => {
        const swipeHintTargetTable = swipeHintTargetDiv.firstElementChild;
        const isOverflowing =
            swipeHintTargetDiv.offsetWidth < swipeHintTargetTable.offsetWidth;
        const swipeHintContainer = swipeHintTargetDiv.previousElementSibling;

        if (isOverflowing) {
            swipeHintContainer.style.display = 'block';
        } else {
            swipeHintContainer.style.display = 'none';
        }
    });
};

const init = () => {
    // check for element on page
    const swipeHintContainer = document.querySelector('[data-swipe-hint]');

    // if we have the element, run through initialization
    if (swipeHintContainer !== null) {
        // display UI hint to swipe if container is too large for mobile (overflow occurs)
        detectXOverflow();
        $(window).resize(() => {
            debounce(detectXOverflow());
        });
    }
};

export { init };
